import React from "react"
import { usePageAssets } from "hooks/usePageAssets"
import Container from "components/ui/Container"
import Heading from "components/ui/Heading"
import Image from "components/ui/Image"

function DataArchitectureSection() {
  const { getAsset } = usePageAssets()
  const dataArchitectureIllustration = getAsset(
    "home-data-architecture-illustration"
  )
  return (
    <Container section>
      <Heading
        label="Data Architecture"
        title="Visualizations for the modern data stack"
        subtitle={
          <>
            Leverage the investments you have made in your data infrastructure
            with Preset’s lightweight and powerful visualization layer on top.
            Preset is agnostic to your underlying data architecture and does not
            require an additional ingestion layer.
          </>
        }
        decoration="line"
      />
      <div className="text-center">
        <Image className="mt-6" src={dataArchitectureIllustration} />
      </div>
    </Container>
  )
}

export default DataArchitectureSection
